var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup537Grey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.051,
    height: 50,
    viewBox: "0 0 50.051 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537",
    transform: "translate(473.473 -144.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3528",
    "data-name": "Path 3528",
    d: "M-427.412,169.156A20.828,20.828,0,0,0-440.9,149.332c-1.628-.642-2-2.228-.78-3.34a1.853,1.853,0,0,1,2.068-.294,23.879,23.879,0,0,1,6.967,4.06,24.835,24.835,0,0,1,8.812,15,24.368,24.368,0,0,1-4.434,19.043,24.054,24.054,0,0,1-16.3,9.944,24.9,24.9,0,0,1-28.187-18.8c-1.847-7.811-.093-14.939,4.711-21.283a23.969,23.969,0,0,1,15.969-9.309,27.972,27.972,0,0,1,3.47-.265,1.763,1.763,0,0,1,1.978,1.84,1.854,1.854,0,0,1-1.982,1.992,21.429,21.429,0,0,0-19.951,14.567,21.141,21.141,0,0,0,14.368,26.97c7.175,2,13.673.316,19.4-4.309a19.87,19.87,0,0,0,7.243-12.938,9.648,9.648,0,0,0,.127-1.133C-427.4,170.438-427.412,169.8-427.412,169.156Z",
    transform: "translate(0)",
    fill: "#575556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3529",
    "data-name": "Path 3529",
    d: "M-337.564,229.429q0-1.593,0-3.186a2.966,2.966,0,0,1,2.27-3,12.838,12.838,0,0,0,2.733-1.179,5.073,5.073,0,0,0,2.5-5.834,6.025,6.025,0,0,0-5.411-4.393,6.008,6.008,0,0,0-5.942,5.477,3.094,3.094,0,0,1-.226.982,1.733,1.733,0,0,1-1.97,1.207,1.97,1.97,0,0,1-1.638-1.948,9.347,9.347,0,0,1,4.819-8.207c6.4-3.832,13.551,1.01,14.3,7.036.512,4.112-1.443,6.99-4.727,9.137a12.934,12.934,0,0,1-2.374,1.129.645.645,0,0,0-.5.731q.03,2.825,0,5.651a1.883,1.883,0,0,1-1.956,1.863,1.861,1.861,0,0,1-1.881-1.86c-.01-.4,0-.8,0-1.2Q-337.564,230.632-337.564,229.429Z",
    transform: "translate(-112.803 -56.215)",
    fill: "#575556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3530",
    "data-name": "Path 3530",
    d: "M-279.469,467.9a1.887,1.887,0,0,1-1.879-1.984,1.941,1.941,0,0,1,1.962-1.866A1.96,1.96,0,0,1-277.5,466,1.907,1.907,0,0,1-279.469,467.9Z",
    transform: "translate(-169.023 -281.492)",
    fill: "#575556"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup537Grey);
export default __webpack_public_path__ + "static/media/Group 537-grey.2d3c3876256d3e48f0e80b5f07746d86.svg";
export { ForwardRef as ReactComponent };